export enum optionTypeEnum {
  list, chat, method, link
}

export interface HelpButtonOption {
  label: string,
  optionType: optionTypeEnum,
  options?: HelpButtonOption[],
  hide?: boolean,
  parent?: HelpButtonOption,
  icon?: string,
  title?: string,
  action?: string,
  href?: string,
  method?: string,
  onlyLogged?: boolean,
  onlyAnonimus?: boolean,
  hasNotification?: boolean
}


const supportOptions: HelpButtonOption = {
  label: 'Soporte',
  icon: '/assets/support/support.svg',
  optionType:optionTypeEnum.list,
  options: [
    {
      icon: '/assets/svg/chat.svg',
      label: 'Iniciar chat',
      optionType: optionTypeEnum.chat
    },
    {
      icon: '/assets/support/support.svg',
      label: 'Soporte de mis compras',
      optionType: optionTypeEnum.link,
      href: '/cuenta/soporte/ordenes',
      onlyLogged: true
    },
    { 
      icon: '/assets/svg/inicio-sesion.svg',
      label: 'Problemas para iniciar sesión',
      optionType: optionTypeEnum.method,
      action: 'openSessionModal',
      onlyAnonimus: true
    },
    { 
      icon: '/assets/svg/payment.svg',
      label: 'Problemas con mi pago',
      optionType: optionTypeEnum.method,
      action: 'payment',
      onlyLogged: true      
    },
    { 
      icon: '/assets/svg/store.svg',
      label: 'Información de tiendas',
      optionType: optionTypeEnum.link,
      href: '/tiendas'
    },
    { 
      hasNotification: true,
      icon: '/assets/svg/bell.svg',
      label: 'Notificaciones',
      optionType: optionTypeEnum.link,
      href: '/cuenta/notificaciones/listado',
    },
  ]
}

const salesOptions: HelpButtonOption = {
  label: 'Ventas',
  icon: '/assets/support/sales.svg',
  optionType:optionTypeEnum.list,
  options: [
    {
      icon: '/assets/support/sales.svg',
      label: 'Quiero comprar',
      optionType: optionTypeEnum.chat,
    },
    {
      icon: '/assets/support/dermo.svg',
      label: 'Asesoría Dermocosmética',
      optionType: optionTypeEnum.chat,
    },
    {
      icon: '/assets/support/farma.svg',
      label: 'Asesoría Farmacéutica',
      optionType: optionTypeEnum.chat
    },
  ]
}

export const HelpButtonOptions: HelpButtonOption[] = [
  {
    label: 'Soporte y Ventas',
    title: '¡Hola!<br/>Como podemos ayudarte hoy',
    optionType: optionTypeEnum.list,
    options:[ supportOptions, salesOptions ]
  }
]

export const HelpButtonDepartments = {
  ASESORIA_FARMACEUTICA: 1260812486310,
  ASESORIA_DERMOCOSMETICA: 1260812482649,
  ATENCION_CLIENTE: 4415197433115,
  SOPORTE_DOMICILIO: 13434965431451,
}
